module.exports = __webpack_public_path__ + "static/media/Dinesh.50c121e3.png";